import React, { useState } from "react";
import "../styles/Navbar.css";

const Navbar = ({ nav = [], initials = "" }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <a href="#about" className="navbar-logo" onClick={scrollToTop}>
        <span className="logo-text">{initials}</span>
      </a>

      <button
        className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
        aria-controls="navbar-list"
      >
        <span className="navbar-toggle-bar"></span>
        <span className="navbar-toggle-bar"></span>
        <span className="navbar-toggle-bar"></span>
      </button>

      <ul id="navbar-list" className={`navbar-list ${isMenuOpen ? 'active' : ''}`}>
        {nav.map((item) => (
          <li key={item.href} className="navbar-item">
            <a href={item.href} className="navbar-link" onClick={handleLinkClick}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
